import React, { Component } from "react";
import "./saveTradeImage.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";
import html2canvas from "html2canvas";
import NumberInput from "antd-mobile/lib/input-item/CustomInput";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class saveTradeImage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            userId : "",
            resultObject : {},
            showImg : "http://image.ybk008.com/checkNumberheader.png",
            userId : "",
            dealStatus : "",
            dealStatusImage : "sy_jiaogezhong.png",
            type: "",
            goodstypeimage :"sy_sell.png",
            allGoodstag : "",
            postage : "",
            grageString : "未评级",
            futuresName : "",
            dealPattern: "担保交易",
            bondAmount : "",
            pubUserInfo:{
                portrait : "",
                authType : "",
            },
            doUserInfo :{
                portrait : "",
                authType : "",
            },
            goodsOrder:{
                goodsDesc : "",
                authType: "",
            },
            orderInfo:{
                imageUrl:"",
            },
        };
    }

     getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    saveWindowImage = ()=>{//保存图片

        this.setState({
            saveimgPrompt : "正在生成图片",
        })
        const captureElement = document.getElementById('all_content_id');
        const options = {
            scale: window.devicePixelRatio, // 高清缩放
            width: window.innerWidth,
            height: window.height,
            useCORS: true, // 解决跨域资源问题
        };
        
        html2canvas(captureElement, options).then(canvas => {
            let imgData = canvas.toDataURL('image/png' , 0.3);
            var ua = navigator.userAgent.toLowerCase();
            var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
            let imageData = imgData.substring(imgData.indexOf(',') + 1);
            if (isApp) {
                if (isiOS) {
                    try {
                        window.webkit.messageHandlers.IOSNativeSaveImage.postMessage({"imageData" : imageData});
                    } catch (e) {
                    }
                }else{
                    try {
                        window.app.androidNativeSaveImage(imageData);
                    } catch (e) {
                    }
                }
            }
        });
    }

    componentDidMount (){

        sessionStorage.setItem("Authorization",this.getUrlParam('tokenHead')+' '+this.getUrlParam('tokenCode'));
        sessionStorage.setItem("cAppVersion",this.getUrlParam('v'));
        let userId = this.getUrlParam('userId');
        let oid = this.getUrlParam('oid');
        const newDate = formatDate();

        const _this = this;
        axios
            .post("data/json/getScreenshotDetails",{userId : userId, oid : oid, pageType : 'deal'})
            .then(function (response){
                
                if (response.data.code === 10000) {
                    let resultObject = response.data.resultObject;
                    let goodsOrder = resultObject.goodsOrder;
                    let pubUserInfo = goodsOrder.pubUserInfo;
                    let orderInfo = resultObject.orderInfo;
                    let doUserInfo = orderInfo.doUserInfo;

                    let dealStatus = "";
                    let dealStatusImage = "sy_jiaogezhong.png";
                    switch (parseInt(orderInfo.dealStatus) ) {
                        case 1:
                            dealStatus = "交割中";
                            dealStatusImage = 'sy_jiaogezhong.png';
                            break;
                        case 2:
                            dealStatus = "交割成功";
                            dealStatusImage='sy_jiaogechenggong.png';
                            break;
                        case 3:
                            dealStatus = "交割失败";
                            dealStatusImage = 'sy_jiaogeshibai.png';
                            break;
                        default:
                            break;
                    }

                    let allGoodstag = "";
                    if (!(goodsOrder.bondAmount === '0') && goodsOrder.goodsTag === 'PJ' ) {
                        allGoodstag =  "YB_bondAndPing_goods_icon.png";
                    }else if (!(goodsOrder.bondAmount === '0')) {
                        allGoodstag = "YB_bond_golden_goods_icon.png";
                    } else if (goodsOrder.goodsTag === 'PJ') {
                        allGoodstag = "YB_ping_goods_icon.png";
                    }else if (goodsOrder.goodsTag === 'PH') {
                        allGoodstag = "YB_pei_goods_icon.png";
                    }
                
                    var grageString = "未评级";
                    let futuresName = "现货";
                    let goodstypeimage = "sy_sell.png";
                    switch (parseInt(goodsOrder.goodsType)) {
                        case 1:
                        case 3:
                            if (goodsOrder.goodsState === '2') {
                                futuresName = "预买";
                            }
                            if (goodsOrder.goodsTag === 'PJ') {
                                grageString = "商品必须已评级";
                            }
                            if (parseInt(goodsOrder.goodsType) === 3) {
                                goodstypeimage = "sy_flashbuy.png"
                            } else {
                                goodstypeimage = "sy_buy.png"
                            }
                            break;
                        case 2:
                        case 4:
                            if (goodsOrder.goodsState === '2') {
                                futuresName = "预售";
                            }
                            if (goodsOrder.goodsTag === 'PJ') {
                                grageString = "已评级";
                            }
                            if (parseInt(goodsOrder.goodsType) === 4) {
                                goodstypeimage = "sy_flashsell.png";
                            } else {
                                goodstypeimage = "sy_sell.png";
                            }
                            break;
                        default:
                            break;
                    }
                    let dealPattern = "担保交易";
                    switch (goodsOrder.tradeType) {
                        case '2':
                            dealPattern = "担保交易";
                            break;
                        case '3':
                            dealPattern = "线下交易";
                            break;
                        default:
                            break;
                    }

                    let postage = "";
                    if (goodsOrder.postage) {
                        if (goodsOrder.postage === '0') {
                            postage = "包邮";
                        }else{
                            postage = "不包邮";
                        }  
                    }

                    _this.setState({
                        userId : userId,
                        newDate : newDate,
                        resultObject : resultObject,
                        goodsOrder : goodsOrder,
                        pubUserInfo : pubUserInfo,
                        orderInfo : orderInfo,
                        doUserInfo :doUserInfo,
                        type :goodsOrder.goodsType,
                        goodstypeimage :goodstypeimage,
                        allGoodstag :allGoodstag,
                        grageString : grageString,
                        futuresName : futuresName,
                        dealPattern :dealPattern,
                        postage : postage,
                        dealStatus : dealStatus,
                        dealStatusImage :dealStatusImage,
                    })

                    setTimeout(() => {
                        _this.saveWindowImage();
                    }, 500);
                }else {
                    let message = response.data.message;
                    Toast.show(message, 2);
                }
            })

            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        return (
            <div className="saveTradeImage_div">
                 <div id="all_content_id" className="all_content_div">
                    <div className="navTitle_div">
                        <p className="navtitle_p"> 邮宝APP</p>
                    </div>
                    <div className="deal_status_div">
                        <img className="deal_status_img" src={require("../assets/YB_me_order_icon_dd@2x.png")}></img>
                        <p className="deal_status_p">{this.state.dealStatus}</p>
                    </div>

                    <div className="content_div">
                        
                        <div className="title_price_div">
                            <img className="goodsImage_img" src={this.state.orderInfo.imageUrl.length > 0 ? this.state.orderInfo.imageUrl :require("../assets/YB_GoodsPreloadBackground_Iocn@3x.png")}/>
                            <div className="left_column_div">
                                <div className="goodsName_div">
                                    <img className="buysell_img" src={require("../assets/" + this.state.goodstypeimage)}></img>
                                    {this.state.allGoodstag.length >0 ?(<img className="buysell_img" src={require('../assets/'+ this.state.allGoodstag)}></img>):null} 
                                    <p className="title_p">{this.state.resultObject.title}</p>
                                </div>
                                <div className="price_div">
                                    <p>￥<span className="priceNumber_span">{this.state.resultObject.price}</span><span className="unit_span">/{this.state.resultObject.unit}</span></p> 
                                    <button className="postage_button">{this.state.postage}</button>
                                </div>
                                
                            </div>
                        </div>
                        <p className="nickName_p">{this.state.resultObject.nickname} {this.state.newDate}</p>

                        <div className="goods_list_div">
                            <div className="class_list_div">
                                <div className="lift_nameType_div">
                                    <p className="nametype_p">交易类别：{this.state.type === '1' || this.state.type === '3' ? "买盘"  : "卖盘"}</p>
                                    <p className="nametype_p">剩余数量: <span className="red_span">{this.state.goodsOrder.reminderNum}</span></p>
                                    <p className="nametype_p">最小确认量: {this.state.goodsOrder.dealMinNum}</p>
                                    <p className="nametype_p">保证金总份数: {this.state.goodsOrder.totalBondNum}</p>
                                    <p className="nametype_p">单份保证金: <span className="red_span">{this.state.goodsOrder.bondAmount}</span></p>
                                    <p className="nametype_p">交易方式: {this.state.dealPattern}</p>
                                </div>
                                <div className="center_line_div"></div>
                                <div className="right_nameType_div">
                                    <p className="nametype_p">分类：{this.state.goodsOrder.categoryName}</p>
                                    <p className="nametype_p">成交数量: <span className="red_span">{this.state.orderInfo.dealNum}</span></p>
                                    <p className="nametype_p">品相: <span className="green_span">{this.state.goodsOrder.conditionName}</span></p>
                                    <p className="nametype_p">评级鉴定: {this.state.grageString}</p>
                                    <p className="nametype_p">货物状态: {this.state.futuresName}</p>
                                    <p className="nametype_p">成交时间: {this.state.orderInfo.orderTime}</p>
                                </div>
                                <img className="deal_status_Bigimg" src={require('../assets/'+ this.state.dealStatusImage)}></img>
                            </div>
                            
                        </div>

                        {this.state.goodsOrder.goodsDesc.length > 0 ?
                            (<div className="list_two_div">
                                <img className="desc_img" src={require("../assets/YB_TD_describe_Icon@2x.png")}></img>
                                <p className="twonametype_p">商品描述:<span className="twotypeContent_span">{this.state.goodsOrder.goodsDesc}</span></p>
                            </div>
                            )
                        : null}

                        <div className="userdata_div">
                            <img className="userHeader_img" src={this.state.pubUserInfo.portrait.length >0 ? (this.state.pubUserInfo.portrait) : require("../assets/grzx_touxiang@2x.png")}></img>
                            <img className="useridentity_img" src={require("../assets/YB_TD_ReleasePeople_Logo_Icon@2x.png")}></img>
                            <div className="userName_div">
                                <p className="username_p">{this.state.pubUserInfo.nickname}<span className="levle_span">Lv.{this.state.pubUserInfo.level}</span></p>
                                <img className="uesrtag_img" src={this.state.pubUserInfo.authType === "商家" ? require("../assets/smrz_shangjiabiaoqianIcon@2x.png") : this.state.pubUserInfo.authType === "个人"? require("../assets/smrz_gerenbiaoqianIcon@2x.png") :require("../assets/smrz_weirenzhenicon@2x.png")}></img>
                            </div> 
                        </div>
                        
                         <div className="userdata_div doUserdata_div">
                            <img className="userHeader_img" src={this.state.doUserInfo.portrait.length >0 ? (this.state.doUserInfo.portrait) : require("../assets/grzx_touxiang@2x.png")}></img>
                            <img className="useridentity_img" src={require("../assets/YB_TD_TradersPeople_Logo_Icon@2x.png")}></img>
                            <div className="userName_div">
                                <p className="username_p">{this.state.doUserInfo.nickname}<span className="levle_span">Lv.{this.state.doUserInfo.level}</span></p>
                                <img className="uesrtag_img" src={this.state.doUserInfo.authType === "商家" ? require("../assets/smrz_shangjiabiaoqianIcon@2x.png") : this.state.doUserInfo.authType === "个人"? require("../assets/smrz_gerenbiaoqianIcon@2x.png") :require("../assets/smrz_weirenzhenicon@2x.png")}></img>
                            </div> 
                        </div>

                    </div>
                    
                </div>
           </div>
        );   
    }
}

function formatDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default saveTradeImage;
